/* eslint-disable */
import { getJCP } from './jcp'
var DDDY = (function() {
	// var dddy_root = "http://dddy.sen-chang.cn/printer/";
	// var dddy_root = "http://localhost:8080/printer/";
	var dddy_root = process.env.VUE_APP_DDDY_ROOT
	// 改成你自己的服务器网址
	if (window['JCP'])
			JCP.licenseURL = "/printer/service/lic.jsp";

	var cgi = dddy_root + "api?";
	var JSONparse = JSON.parse || function(str) {
			if (str === "") {
					str = '""'
			}
			eval("var p=" + str + ";");
			return p
	}
	;
	function ajax(url, data, callback) {
			try {
					if (typeof data !== "string") {
							data = JSON.stringify(data)
					}
					var x = new (window.XDomainRequest || window.XMLHttpRequest || ActiveXObject)("MSXML2.XMLHTTP.3.0");
					x.open(data ? "POST" : "GET", url, 1);
					if (window.XDomainRequest) {
							x.onload = function() {
									var data = JSONparse(x.responseText || "{}");
									callback && callback(data, x.responseText, 200)
							}
							;
							x.ontimeout = function() {
									callback && callback(data, x.responseText, 404)
							}
							;
							x.onerror = function() {
									callback && callback(data, x.responseText, 404)
							}
							;
							x.send(data)
					} else {
							x.onreadystatechange = function() {
									try {
											var data = JSONparse(x.responseText || "{}");
											x.readyState > 3 && callback && callback(data, x.responseText, x.status)
									} catch (e) {
											console.log(e)
									}
							}
							;
							x.send(data)
					}
			} catch (e) {
					console.log(e)
			}
	}
	function getToken(key, callback) {
			ajax(cgi, {
					method: "getToken",
					key: key
			}, function(data) {
					callback && callback(data)
			}, "json")
	}
	function newTemplate(token, datasource, dataset, tid, saved, opened) {
		if (Array.isArray(dataset)) {
				dataset = JSON.stringify(dataset)
		}
		ajax(cgi, {
				method: "newTemplate",
				token: token,
				datasource: datasource,
				dataset: dataset || "[]"
		}, function(data) {
			if (!data.error_code) {
					data.url = dddy_root + "d?did=" + data.did + "&pid=" + (data.pid || "")
			}
			if (!data.error_code) {
					getJCP().getVersion(function() {
							data.url += ("&tab=" + getJCP().tab);
							data.url += ("&tid=" + tid);
							window.open(data.url);
							if (saved) {
									getJCP().getMessage(function(data) {
											saved(data)
									})
							}
					})
			}
			opened && opened(data)
		}, "json")
	}
	function openTemplate(token, tid, dataset, opened, saved) {
			if (Array.isArray(dataset)) {
					dataset = JSON.stringify(dataset)
			}
			ajax(cgi, {
					method: "openTemplate",
					token: token,
					tid: tid,
					dataset: dataset || "[]"
			}, function(data) {
					if (!data.error_code) {
							data.url = dddy_root + "d?tid=" + tid + "&pid=" + (data.pid || "")
					}
					if (!data.error_code) {
							getJCP().getVersion(function() {
									data.url += ("&tab=" + getJCP().tab);
									window.open(data.url);
									if (saved) {
											getJCP().getMessage(function(data) {
													saved(data)
											})
									}
							})
					}
					opened && opened(data)
			}, "json")
	}
	function decodeEvent(that, data, row, flag) {
		getJCP().getDefaultPrinter(printer => {
			getJCP().getPrinterJobs(printer, jobs => {
				let arr = []
				jobs.forEach(item => {
					arr.push(item.id)
				})
				let tmp = [...that.jobList1, ...arr]
				that.jobList1 = Array.from(new Set(tmp))
				let len = that.jobList1.length - jobs.length
				while (len > 0) {
					that.apiUpdateStatus(that, data, row, flag)
					len--
				}
				that.jobList1 = [...arr]
			})
		})
	}
	function print(token, tid, dataset, prompt, callback) {
			if (Array.isArray(dataset)) {
					dataset = JSON.stringify(dataset)
			}
			ajax(cgi, {
					method: "registerDataset",
					token: token,
					tid: tid,
					dataset: dataset || "[]"
			}, function(data) {
					if (!data.error_code) {
							var url = dddy_root + "service/buildPage.jsp?tid=" + tid + "&pid=" + data.pid;
							var myDoc = {
									// settings: {
									// 	printer,
									// 	marginLeft: 2, // 单位mm
									// },
									settings: 'auto',
									keepURL: true,
									noMargins: true,
									enableScreenOnlyClass: true,
									documents: url,
									copyrights: "杰创软件拥有版权  www.jatools.com",
									done: callback || null
									// ,listener: function(e) {
                  //   decodeEvent(that, datas, row, flag)
                  // }
							};
							if (callback) {
									myDoc.done = callback
							}
							getJCP().print(myDoc, prompt)
					} else {
							callback && callback(data)
					}
			}, "json")
	}
	function printPreview(token, tid, dataset, prompt) {
			if (Array.isArray(dataset)) {
					dataset = JSON.stringify(dataset)
			}
			ajax(cgi, {
					method: "registerDataset",
					token: token,
					tid: tid,
					dataset: dataset || "[]"
			}, function(data) {
					if (!data.error_code) {
							var url = dddy_root + "service/buildPage.jsp?tid=" + tid + "&pid=" + data.pid;
							var myDoc = {
									keepURL: true,
									settings: "auto",
									noMargins: true,
									enableScreenOnlyClass: true,
									documents: url,
									copyrights: "杰创软件拥有版权  www.jatools.com"
							};
							getJCP().printPreview(myDoc, prompt)
					}
			}, "json")
	}
	function getDatasource(token, template_id, callback) {}
	function getTemplate(token, template_id, callback) {}
	function getTemplates(token, callback) {}
	function buildPages(token, template_id, data, options, callback) {}
	return {
			getToken: getToken,
			newTemplate: newTemplate,
			openTemplate: openTemplate,
			print: print,
			printPreview: printPreview,
			getDatasource: getDatasource,
			getTemplate: getTemplate,
			getTemplates: getTemplates,
			buildPages: buildPages
	}
}
)();

export default DDDY
